export enum MeetingViewEnum {
  notes = "Topics",
  summary = "Meeting Recap",
  previousMeetingSummary = "Last Meeting Recap",
}
